//
// Generated class EventItem
//

/// <reference path="EventItem_ManagedObject.ts" />

class EventItem extends EventItem_ManagedObject
{

}
